import { Autocomplete, Checkbox, FormControl, TextField } from '@mui/material';
import { NShiftPartnerServiceAddon } from 'models/nshift-partners';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

type NShiftServiceAddonsAutoCompleteProps = {
    nShiftServiceAddons: NShiftPartnerServiceAddon[];
    savedAddons?: NShiftPartnerServiceAddon[];
    onAddonsSelect: (addons: NShiftPartnerServiceAddon[]) => void;
};

const NShiftServiceAddonsAutoComplete: FC<NShiftServiceAddonsAutoCompleteProps> = ({
    nShiftServiceAddons,
    savedAddons,
    onAddonsSelect,
}: NShiftServiceAddonsAutoCompleteProps) => {
    const { t: translate } = useTranslation('transport');
    const [selectedAddons, setSelectedAddons] = useState<NShiftPartnerServiceAddon[]>([]);

    useEffect(() => {
        if (savedAddons?.length) {
            setSelectedAddons(savedAddons);
        }
    }, [savedAddons]);

    const handlePartnerServiceAddonSelect = (
        _: React.SyntheticEvent,
        selectedPartnerServiceAddons: (NShiftPartnerServiceAddon | any)[],
    ) => {
        setSelectedAddons(selectedPartnerServiceAddons);
        onAddonsSelect(selectedPartnerServiceAddons);
    };

    return (
        <FormControl fullWidth>
            <Autocomplete
                fullWidth
                disableClearable
                disableCloseOnSelect
                multiple
                sx={{ minWidth: 300 }}
                value={selectedAddons}
                id="nshift-partner-service-addon-label"
                options={nShiftServiceAddons}
                onChange={handlePartnerServiceAddonSelect}
                freeSolo
                isOptionEqualToValue={(option: NShiftPartnerServiceAddon, value: NShiftPartnerServiceAddon) =>
                    option?.id === value?.id
                }
                renderOption={(props, option, { selected }) => (
                    <li {...props}>
                        <Checkbox
                            color="secondary"
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                        />
                        {option.description} ({option.id})
                    </li>
                )}
                getOptionLabel={(option: NShiftPartnerServiceAddon | string) => {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option.description} (${option.id})`;
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={translate('transport:SELECT_ADDONS')}
                        placeholder="Enter Addon Name"
                    />
                )}
            />
        </FormControl>
    );
};

export default NShiftServiceAddonsAutoComplete;
